import type { FC } from "react";
import { cn } from "@/lib/utils";

interface HeaderProps {
  heading: string | undefined;
  dateUpadted: string | undefined;
  maticRobotHeading: string | undefined;
  className?: string;
}

const Header: FC<HeaderProps> = ({
  dateUpadted,
  maticRobotHeading,
  className,
}) => {
  return (
    <div
      className={cn(
        "mb-[80px] mt-[80px] text-center md:mb-[120px] md:mt-[120px]",
        className,
      )}
    >
      <h1>{maticRobotHeading}</h1>
      {/* <h5 className="mb-[8px] mt-[8px]">{heading}</h5> */}
      <p>{dateUpadted}</p>
    </div>
  );
};

export default Header;
